import _ from "lodash";
import documentClient from "../awsAPIs/dynamoDb";
// import swal from 'sweetalert'
import moment from "moment";
import swal from "sweetalert";
// import * as type from "../types/memberTx";

const queryTransactionsByMemberId = async (memberUid) => {
  let items = [];
  let lastEvaluatedKey = null;

  do {
    const params = {
      TableName: "Wallet_Transactions",
      KeyConditionExpression: "memberUid = :memberUid",
      ExpressionAttributeValues: {
        ":memberUid": memberUid,
      },
    };

    if (lastEvaluatedKey) {
      params.ExclusiveStartKey = lastEvaluatedKey;
    }

    const result = await documentClient.query(params).promise();
    items = items.concat(result.Items || []);
    lastEvaluatedKey = result.LastEvaluatedKey;
  } while (lastEvaluatedKey);

  return items;
};

const sumWalletBalance = (transactions = []) => {
  return transactions.reduce((sum, transaction) => {
    const amount = Number(transaction.amount);
    return sum + (Number.isFinite(amount) ? amount : 0);
  }, 0);
};

const updateMemberWalletBalance = (tableName, memberUid, walletBalance) => {
  return documentClient
    .update({
      TableName: tableName,
      Key: {
        uid: memberUid,
      },
      UpdateExpression: "SET walletBalance = :walletBalance",
      ExpressionAttributeValues: {
        ":walletBalance": walletBalance,
      },
    })
    .promise();
};

export const pushMemberTx = (memberUid, txType, options, cb) => {
  //options - amount,remark,type,refId

  //! Function Stream อยู่ใน Project "divana-api" ชื่อ "updateMemberWalletBalance"

  return (dispatch, getState) => {
    const { shop, employee } = getState();

    if (!options.amount || !options.type) {
      alert("กรุณาระบุ Amount และ Type");
      return;
    }

    var params = {
      TableName: getTxTypeTable(txType),
      Item: {
        memberUid,
        timestamp: moment().toISOString(), 
        amount: options.amount,
        remark: options.remark === "" ? null : options.remark,
        type: options.type.toUpperCase(), //TOPUP, SPEND,ADJUST
        store: shop.detail,
        hqUid: shop.linked.invetory || shop.detail.uid,
        employee: employee.current,
        refId: options.refId === "" ? null : options.refId
      }
    };
    documentClient.put(params, (err, res) => {
      if (err) {
        console.log(err);
        return;
      }

      cb && cb();
    });
  };
};

export const fetchMemberTx = (memberUid, txType, cb) => {
  return (dispatch, getState) => {
    var params = {
      TableName: getTxTypeTable(txType),
      //   IndexName: "Index",
      KeyConditionExpression:
        // "memberUid = :memberUid and timestamp = :timestamp",
        "memberUid = :memberUid",
      //   ExpressionAttributeNames: { "#timestamp": "timestamp" },
      ExpressionAttributeValues: {
        ":memberUid": memberUid
        // ":timestamp": timestamp
      }
    };

    documentClient.query(params, function(err, data) {
      if (err) {
        console.log(err);
      } else {
        let orderedDesc = _.orderBy(data.Items, "timestamp", "desc");
        cb && cb(orderedDesc);
      }
    });
  };
};

export const computeBalance = (memberUid, cb) => {
  return async () => {
    const normalizedMemberUid = String(memberUid || "").trim();

    if (!normalizedMemberUid) {
      cb && cb(new Error("memberUid is required"));
      return;
    }

    try {
      const transactions = await queryTransactionsByMemberId(normalizedMemberUid);
      const walletBalance = sumWalletBalance(transactions);

      await updateMemberWalletBalance(
        "Crm_Users",
        normalizedMemberUid,
        walletBalance
      );

      try {
        await updateMemberWalletBalance(
          "Crm_Users2",
          normalizedMemberUid,
          walletBalance
        );
      } catch (secondaryError) {
        console.log("computeBalance Crm_Users2 update skipped", secondaryError);
      }

      cb &&
        cb(null, {
          memberUid: normalizedMemberUid,
          walletBalance,
          transactionCount: transactions.length,
        });
    } catch (error) {
      console.log(error);
      swal("Error", "Compute wallet balance failed", "error");
      cb && cb(error);
    }
  };
};

const getTxTypeTable = type => {
  switch (type) {
    case "wallet":
      return "Wallet_Transactions";
    case "point":
      return "Point_Transactions";
    default:
      break;
  }
};
